<template>
    <div class="article-faqs-tile-clothes">
        <p>
            Wear something that you feel comfortable in that allows you to move around. There's no specific clothes you
            need for dancing, just stuff that's not too tight or restrictive.
        </p>
        <p>
            You don't need dance shoes, trainers that are pretty slippy will do just fine. Otherwise if you want to get
            a pair of dance shoes, they're definitely worthwhile - we recommend
            <a href="https://swayd.eu/" target="_blank" rel="noopener noreferrer nofollow">SwayD</a>, they have some
            great options. Just don't wear them outside, you'll ruin the suede soles.
        </p>
        <p>
            If you do have dance shoes, we recommend you avoid shoes with a high heel. You're better off in fairly flat
            shoes for swing.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleFaqsTileClothes',
};
</script>
